import { useSearchParams } from 'react-router'
import { useSelector } from 'react-redux'
import scopeCss from 'scope-css'

// Once it breaks we need to come up with a more sophisticated solution.
// Also strips block comments
export default function CustomCss({ src = '' }) {
  const isEditorMode = useSelector((state: State) => state.getIn(['view', 'editorMode']))
  const [searchParams] = useSearchParams()
  const shouldIgnoreCustomCSS = isEditorMode && searchParams?.get('IgnoreCustomCSS') === '1'

  if (shouldIgnoreCustomCSS) return null

  return src ? <style dangerouslySetInnerHTML={{ __html: scopeCss(src, '.body') }} /> : null
}
